import useStrict from './useStrict';
export { action, actionCreator } from './actionCreator';
export { default as applyMiddleware } from './applyMiddleware';
export { default as createStore } from './createStore';
export { dispatch } from './dispatcher';
export { default as mutator } from './mutator';
import { default as orchestrator } from './orchestrator';
export { default as getRootStore } from './getRootStore';
export { mutatorAction } from './simpleSubscribers';
export { useStrict };
export var flow = orchestrator;
export { orchestrator };
useStrict(true);
